var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"focus w-full"},[_c('Card',{attrs:{"display-type":"carousel","resources":_vm.resources,"carousel-options":_vm.carouselOptions,"isFromFirstSection":true,"title":_vm.settings.first_section.header}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }